import React, { useEffect, useState } from 'react'
import './my-plan.styles.scss'
import Layout from '@/components/layout-auth/layout.comp'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { membershipRestrictions } from '@/utils/membershipRestrictions'
import { changeDocumentTitle } from '@/utils/useDocumentTitle'
import InfoLinks from '@/components/SHARED/info-links/info-links.component'
import { UseCloudFunction } from '@/utils/firebase.utils'
import FullPageLoader from '@/components/loader/full-page-loader.component'
import PlanDetails from './plan-details.component'
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component'

const MyPlan = () => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const [activeButton, setActiveButton] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    changeDocumentTitle();
    var r = document.querySelector(':root');
    r.style.setProperty('--primary', '#674fa7');
    r.style.setProperty('--primary-trans', '#674fa7a6');

    const timeout = setTimeout(() => {
      if (!userProfile && !membership) {
        navigate('/pricing');
      }
    }, 1500);
    return () => clearTimeout(timeout);
  }, [])

  useEffect(() => {
    if (!membership) return;
    setActiveButton(membership.membership);
    console.log(membership)
  }, [membership])

  async function getCustomerPortal() {
    setLoading(true);
    const res = await UseCloudFunction(
      'createStripeCustomerPortal',
      {
        'customerId': userProfile.stripeCustomerId,
        'isTest': false
      }
    )
    console.log(res);
    window.open(res.url, '_blank');
    setLoading(false);
  }

  return (
    <div className='my-plan'>
      
        {
          (membership && userProfile) &&
          <Layout>
          <div className={`my-plan-content ${screenSize}`}>
            <div className='g-card'>
              <div className='section-title with-icon'>
                Your Plan Info
                <div className='buttons'>
                  <button
                    className={`g-button ${screenSize === 'mobile' ? 'med-btn' : ''}`}
                    onClick={() => getCustomerPortal()}>
                    Manage Your Plan
                  </button>
                  <button
                    className={`g-button ${screenSize === 'mobile' ? 'med-btn' : ''}`}
                    onClick={() => navigate('/pricing')}>
                    Upgrade!
                  </button>
                </div>
              </div>
              {
                screenSize === 'mobile' &&
                <div className='g-space-1'></div>
              }
              <div className="g-space-1"></div>
              <hr className='no-margin' />
              <div className='plan-list'>
                <div
                  className={`g-list-item ${membership?.membership === 0
                      ? 'current ' : ''
                    } ${activeButton === 0
                      ? 'active' : ''
                    }`}
                >
                  <ImageContainer
                    src={'/images/icons/free.png'}
                    className='icon'
                  />
                  Basic Plan
                </div>
                <div
                  className={`g-list-item ${membership?.membership === 1
                      ? 'current ' : ''
                    }  ${activeButton === 1
                      ? 'active' : ''
                    }`}
                >
                  <ImageContainer
                    src={'/images/icons/pro.png'}
                    className='icon'
                  />
                  Pro Plan
                </div>
                <div
                  className={`g-list-item ${membership?.membership === 2
                      ? 'current ' : ''
                    }${activeButton === 2
                      ? 'active' : ''
                    }`}
                >
                  <ImageContainer
                    src={'/images/icons/premium.png'}
                    className='icon'
                  />
                  Premium Plan
                </div>
                <div
                  className={`g-list-item ${membership?.membership > 2
                      ? 'current ' : ''
                    }${activeButton === 3
                      ? 'active' : ''
                    }`}
                >
                  <ImageContainer
                    src={'/images/icons/enterprise.png'}
                    className='icon'
                  />
                  Enterprise
                </div>
              </div>
              <div className='g-space-1'></div>
              <PlanDetails />
            </div>
            <div className="g-space-0-5"></div>
            <InfoLinks />
          </div>
          </Layout>
        }
      <FullPageLoader show={loading} />
    </div>
  )
}

export default MyPlan